import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { navigationGuard } from '@partners/kernel';
import { SettingsMap } from '@partners/settings';
import { configRoute, provideTrackerConfig } from '../../../../libs/kernel/src';

const configFeature = (featureModule: any): any => {
  return featureModule;
};

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [navigationGuard],
    providers: [provideTrackerConfig()],
    children: [
      {
        ...configRoute(SettingsMap.amount()),
        loadChildren: () => import('@partners/features/amount').then((m) => configFeature(m.AmountFeatureModule))
      },
      {
        ...configRoute(SettingsMap.agreementIndication()),
        loadChildren: () =>
          import('@partners/features/agreement-indication').then((m) =>
            configFeature(m.CreditAgreementIndicationFeatureModule)
          )
      },
      {
        ...configRoute(SettingsMap.agreementConsent()),
        loadChildren: () =>
          import('@partners/features/agreement-consent').then((m) =>
            configFeature(m.CreditAgreementConsentFeatureModule)
          )
      },
      {
        ...configRoute(SettingsMap.marital()),
        loadChildren: () => import('@partners/features/marital').then((m) => configFeature(m.MaritalFeatureModule))
      },
      {
        ...configRoute(SettingsMap.expense()),
        loadChildren: () => import('@partners/features/expense').then((m) => configFeature(m.ExpenseFeatureModule))
      },
      {
        ...configRoute(SettingsMap.income()),
        loadChildren: () => import('@partners/features/income').then((m) => configFeature(m.IncomeFeatureModule))
      },
      {
        ...configRoute(SettingsMap.refused()),
        loadChildren: () => import('@partners/features/refused').then((m) => configFeature(m.RefusedFeatureModule))
      },
      {
        ...configRoute(SettingsMap.country()),
        loadChildren: () => import('@partners/features/country').then((m) => configFeature(m.CountryFeatureModule))
      },
      {
        ...configRoute(SettingsMap.introduction()),
        loadChildren: () =>
          import('@partners/features/introduction').then((m) => configFeature(m.IntroductionFeatureModule))
      },
      {
        ...configRoute(SettingsMap.welcome()),
        loadChildren: () => import('@partners/features/welcome').then((m) => configFeature(m.WelcomeFeatureModule))
      },
      {
        ...configRoute(SettingsMap.authGuide()),
        loadChildren: () => import('@partners/features/auth-guide').then((m) => configFeature(m.AuthGuideFeatureModule))
      },
      {
        ...configRoute(SettingsMap.authOtp()),
        loadChildren: () => import('@partners/features/auth-otp').then((m) => configFeature(m.AuthOtpFeatureModule))
      },
      {
        ...configRoute(SettingsMap.authLogin()),
        loadChildren: () => import('@partners/features/auth-login').then((m) => configFeature(m.AuthLoginFeatureModule))
      },
      {
        ...configRoute(SettingsMap.scanIntro()),
        loadChildren: () => import('@partners/features/scan-intro').then((m) => configFeature(m.ScanIntroFeatureModule))
      },
      {
        ...configRoute(SettingsMap.scanMethod()),
        loadChildren: () =>
          import('@partners/features/scan-method').then((m) => configFeature(m.ScanMethodFeatureModule))
      },
      {
        ...configRoute(SettingsMap.scanGender()),
        loadChildren: () =>
          import('@partners/features/scan-gender').then((m) => configFeature(m.ScanGenderFeatureModule))
      },
      {
        ...configRoute(SettingsMap.scanDocument()),
        loadChildren: () =>
          import('@partners/features/scan-document').then((m) => configFeature(m.ScanDocumentFeatureModule))
      },
      {
        ...configRoute(SettingsMap.scanPreview()),
        loadChildren: () =>
          import('@partners/features/scan-preview').then((m) => configFeature(m.ScanPreviewFeatureModule))
      },
      {
        ...configRoute(SettingsMap.classify()),
        loadChildren: () => import('@partners/features/classify').then((m) => configFeature(m.ClassifyFeatureModule))
      },
      {
        ...configRoute(SettingsMap.offer()),
        loadChildren: () => import('@partners/features/offer').then((m) => configFeature(m.OfferFeatureModule))
      },
      {
        ...configRoute(SettingsMap.identity()),
        loadChildren: () => import('@partners/features/identity').then((m) => configFeature(m.IdentityFeatureModule))
      },
      {
        ...configRoute(SettingsMap.contact()),
        loadChildren: () => import('@partners/features/contact').then((m) => configFeature(m.ContactFeatureModule))
      },
      {
        ...configRoute(SettingsMap.account()),
        loadChildren: () => import('@partners/features/account').then((m) => configFeature(m.AccountFeatureModule))
      },
      {
        ...configRoute(SettingsMap.proposal()),
        loadChildren: () => import('@partners/features/proposal').then((m) => configFeature(m.ProposalFeatureModule))
      },
      {
        ...configRoute(SettingsMap.address()),
        loadChildren: () => import('@partners/features/address').then((m) => configFeature(m.AddressFeatureModule))
      },
      {
        ...configRoute(SettingsMap.privacy()),
        loadChildren: () => import('@partners/features/privacy').then((m) => configFeature(m.PrivacyFeatureModule))
      },
      {
        ...configRoute(SettingsMap.card()),
        loadChildren: () => import('@partners/features/card').then((m) => configFeature(m.CardFeatureModule))
      },
      {
        ...configRoute(SettingsMap.employment()),
        loadChildren: () =>
          import('@partners/features/employment').then((m) => configFeature(m.EmploymentFeatureModule))
      },
      {
        ...configRoute(SettingsMap.purpose()),
        loadChildren: () => import('@partners/features/purpose').then((m) => configFeature(m.PurposeFeatureModule))
      },
      {
        ...configRoute(SettingsMap.debits()),
        loadChildren: () => import('@partners/features/debits').then((m) => configFeature(m.DebitsFeatureModule))
      },
      {
        ...configRoute(SettingsMap.persona()),
        loadChildren: () => import('@partners/features/persona').then((m) => configFeature(m.PersonaFeatureModule))
      },
      {
        ...configRoute(SettingsMap.signature()),
        loadChildren: () => import('@partners/features/signature').then((m) => configFeature(m.SignatureFeatureModule))
      },
      {
        ...configRoute(SettingsMap.issue()),
        loadChildren: () => import('@partners/features/issue').then((m) => configFeature(m.IssueFeatureModule))
      },
      {
        ...configRoute(SettingsMap.onlineUse()),
        loadChildren: () => import('@partners/features/online-use').then((m) => configFeature(m.OnlineUseFeatureModule))
      },
      {
        ...configRoute(SettingsMap.beneficiaries()),
        loadChildren: () =>
          import('@partners/features/beneficiaries').then((m) => configFeature(m.BeneficiariesFeatureModule))
      },
      {
        ...configRoute(SettingsMap.disclosure()),
        loadChildren: () =>
          import('@partners/features/disclosure').then((m) => configFeature(m.DisclosureFeatureModule))
      },
      {
        ...configRoute(SettingsMap.delivery()),
        loadChildren: () => import('@partners/features/delivery').then((m) => configFeature(m.DeliveryFeatureModule))
      },
      {
        ...configRoute(SettingsMap.summary()),
        loadChildren: () => import('@partners/features/summary').then((m) => configFeature(m.SummaryFeatureModule))
      },
      {
        ...configRoute(SettingsMap.demography()),
        loadChildren: () =>
          import('@partners/features/demography').then((m) => configFeature(m.DemographyFeatureModule))
      },
      {
        ...configRoute(SettingsMap.lead()),
        loadChildren: () => import('@partners/features/lead').then((m) => configFeature(m.LeadFeatureModule))
      },
      {
        ...configRoute(SettingsMap.simulator()),
        loadChildren: () => import('@partners/features/simulator').then((m) => configFeature(m.SimulatorFeatureModule))
      }
    ]
  },
  {
    path: 'message',
    providers: [provideTrackerConfig()],
    loadChildren: () => import('@partners/features/message').then((m) => configFeature(m.MessageFeatureModule))
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      canceledNavigationResolution: 'computed'
    })
  ]
})
export class AppRouterModule {}
